<template>
  <div>
    <NavBar />
    <ModalComp
      v-show="openModal"
      @loadsData="loadsData"
      @tutupModal="closeModal"
      :dataObjek="itemSelected"
      :dataTransPorter="transporter"
      :namaTransporter="namaTransporter"
      :dibuat="dibuat"
    />
    <div class="container">
      <BannerPoster />
      <div class="table-container">
        <b-table striped hover :items="displayedItems" :fields="fields">
          <template #cell(action)="row">
            <b-button
              size="sm"
              @click="getOne(row.item)"
              class="bg-danger mr-2"
            >
              <v-icon color="danger lighten-1" style="color: whitesmoke">
                mdi-arrow-up
              </v-icon>
              Details
            </b-button>
          </template>
        </b-table>
        <b-pagination
          :total-rows="items.length"
          :per-page="10"
          v-model="currentPage"
        />
        <div
          v-show="isDataExist"
          class="bg-secondary text-white"
          style="padding: 5px; border-radius: 10px"
        >
          <p>No Data Found</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import BannerPoster from "../components/BannerPoster.vue";
import ModalComp from "../components/ModalComp.vue";
import axios from "axios";

export default {
  name: "HomeView",
  components: {
    NavBar,
    BannerPoster,
    ModalComp,
  },
  data() {
    return {
      openModal: false,
      isDataExist: true,
      items: [],
      currentPage: 1,
      perPage: 10,
      transporter: "",
      namaTransporter: "",
      dibuat: "",
      itemSelected: {},
      fields: [
        {
          title: "Nomor Dokumen",
          key: "no_dokumen",
          sortable: true,
        },
        {
          title: `Transporter`,
          key: "transporter",
        },
        {
          title: `Tgl Pengajuan`,
          key: "tgl_pengajuan",
          sortable: false,
        },
        {
          title: `Status`,
          key: "status",
          sortable: false,
        },
        {
          title: `Nominal`,
          key: "nominal",
          sortable: false,
        },
        {
          title: `Biaya Lain`,
          key: "biaya_lain",
          sortable: false,
        },
        {
          title: `Tgl Confirm`,
          key: "tgl_confirm",
          sortable: false,
        },
        {
          title: `Detail`,
          key: `action`,
        },
      ],
    };
  },
  methods: {
    async getOne(v) {
      console.log(v.no_dokumen);
      await axios
        .get("https://services.ama.id/eloading/pengajuanOne", {
          params: {
            nomor_dok: v.no_dokumen,
          },
        })
        .then((response) => {
          let objek = response.data;
          objek = objek.data;
          this.namaTransporter = objek[0].transporter;
          this.dibuat = objek[0].dibuat;
          this.transporter = v.no_dokumen;
          this.itemSelected = objek;
          this.openModal = true;
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
    loadsData() {
      axios
        .get("https://services.ama.id/eloading/pengajuan", {
          params: {
            transporter_id: localStorage.getItem("transporter_id"),
            token: ``,
          },
        })
        .then((response) => {
          let objek = response.data;
          objek = objek.data;
          this.isDataExist = objek.length > 0 ? false : true;
          // console.log(objek);
          this.items = objek;
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
    closeModal(v) {
      this.openModal = v;
    },
    callme() {
      console.log("jalan");
    },
  },
  mounted() {
    this.loadsData();
  },
  computed: {
    displayedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.items.slice(start, end);
    },
  },
};
</script>
<style>
.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>